import { FacilityLayoutAttributes, SeatLayoutFacility } from '../charter.types';

const FACILITY_DISPLAY_METADATA_DEFAULT = {
  label: 'Facility',
  color: '#eceff1',
};

const FACILITY_DISPLAY_METADATA: Record<SeatLayoutFacility['facilityType'], { label: string; color: string }> = {
  galley: {
    label: 'Galley',
    color: '#d1c4e9',
  },
  lavatory: {
    label: 'Lavatory',
    color: '#f8bbd0',
  },
};

export const getFacilityLayoutAttributes = (facility: SeatLayoutFacility): FacilityLayoutAttributes => {
  const defaults = FACILITY_DISPLAY_METADATA[facility.facilityType] ?? {
    label: facility.facilityType,
    color: FACILITY_DISPLAY_METADATA_DEFAULT.color,
  };

  const columnSpan = Math.max(1, facility.spanUnits ?? 1);

  return {
    columnSpan,
    placement: facility.placement,
    label: facility.label ?? defaults.label,
    color: defaults.color,
  };
};
